import IconContentAdd from '@mui/icons-material/Add';
import IconKeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import IconImageEye from '@mui/icons-material/RemoveRedEye';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import React, { useCallback, useState } from 'react';
import { Button, Create, ReferenceInput, ReferenceInputProps, SelectInput, SimpleShowLayout, useGetOne } from 'react-admin';
import { useFormContext } from 'react-hook-form';

interface QuickCreateButtonProps {
  onChange: () => void,
  source: string,
  resource: string,
  formElements?: React.ReactElement,
}
function QuickCreateButton({ resource, source, onChange, formElements }: QuickCreateButtonProps) {
  const [showDialog, setShowDialog] = useState(false);
  // const [create] = useCreate();
  // const notify = useNotify();
  const { setValue } = useFormContext();

  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const onSuccess = (data: any) => {
    setShowDialog(false);
    setValue(source, data.id, { shouldDirty: true });
    onChange();
  };

  console.log(formElements);

  return (
    <>
      <IconButton onClick={handleClick}>
        <IconContentAdd />
      </IconButton>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label="Create"
      >
        <DialogTitle>Create</DialogTitle>
        <Create resource={resource} redirect={false} mutationOptions={{ onSuccess }}>
          {formElements as any}
          {/* <Form>
            <DialogContent>
            </DialogContent>
            <DialogActions>
              <Button label="ra.action.cancel" onClick={handleCloseClick}>
                <IconCancel />
              </Button>
              <SaveButton />
            </DialogActions>
          </Form> */}
        </Create>
      </Dialog>
    </>
  );
}

interface QuickPreviewButtonProps {
  id: any,
  resource: string,
  fields: React.ReactElement,
}

const QuickPreviewButton = ({ id, resource, fields }: QuickPreviewButtonProps) => {
  const [showPanel, setShowPanel] = useState(false);
  // const classes = useStylesQuickPreviewButton();
  const { data, isLoading } = useGetOne(resource, { id });

  const handleClick = () => {
    setShowPanel(true);
  };

  const handleCloseClick = () => {
    setShowPanel(false);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <IconImageEye />
      </IconButton>
      <Drawer anchor="right" open={showPanel} onClose={handleCloseClick} PaperProps={{ sx: { width: "40vw" } }}>
        <div>
          <Button label="Close" onClick={handleCloseClick}>
            <IconKeyboardArrowRight />
          </Button>
        </div>
        {isLoading
          ? <>Loading</>
          :
          <SimpleShowLayout record={data}>
            {fields.props.children}
          </SimpleShowLayout>
        }
      </Drawer>
    </>
  );
};

interface ReferenceQuickCreateInputProps extends Omit<ReferenceInputProps, 'children'> {
  reference: string,
  source: string,
  showQuick?: boolean,
  fields?: React.ReactElement,
  formElements?: React.ReactElement,
  selectInputProps?: {
    optionText: string,
  }
}

const ReferenceQuickCreateInput = ({ formElements, source, fields, selectInputProps, ...props }: ReferenceQuickCreateInputProps) => {
  // const classes = useStyles();
  const [version, setVersion] = useState(0);
  const { getValues } = useFormContext();
  // const { values } = useFormState({ subscription: spySubscription });
  const handleChange = useCallback(() => setVersion(version + 1), [version]);
  // const valueKey = `${props.reference as string}_id`;
  const valueKey = source;
  const values = getValues();

  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <ReferenceInput key={version} source={source} {...props}>
        <SelectInput fullWidth {...selectInputProps} />
      </ReferenceInput>

      {formElements ? <QuickCreateButton onChange={handleChange} source={source} resource={props.reference as string} formElements={formElements} /> : null}
      {(!!values[valueKey] && fields) ? <QuickPreviewButton id={values[valueKey]} resource={props.reference as string} fields={fields} /> : <IconButton onClick={() => { }} disabled>
        <IconImageEye />
      </IconButton>}
    </div>
  );
};

ReferenceQuickCreateInput.defaultProps = {
  showQuick: true,
  selectInputProps: {
    optionText: 'id',
  }
}

export default ReferenceQuickCreateInput;
